/**
 * Copyright (C) 2021 Tencent.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export default {
  bold: 'Bold',
  code: 'Code',
  graph: 'Graph',
  h1: 'Heading 1',
  h2: 'Heading 2',
  h3: 'Heading 3',
  h4: 'Heading 4',
  h5: 'Heading 5',
  header: 'Header',
  insert: 'Insert',
  italic: 'Italic',
  list: 'List',
  quickTable: 'Quick Table',
  quote: 'Quote',
  size: 'Size',
  color: 'Text Color & Background',
  strikethrough: 'Strikethrough',
  sub: 'Sub',
  sup: 'Sup',
  togglePreview: 'Toggle Preview',
  fullScreen: 'Full Screen',
  image: 'Image',
  audio: 'Audio',
  video: 'Video',
  link: 'Link',
  hr: 'Horizontal Rule',
  br: 'New Line',
  toc: 'Table Of Content',
  pdf: 'PDF',
  word: 'Word',
  table: 'Table',
  'line-table': 'Line Table',
  'bar-table': 'Bar Table',
  'radar-table': 'Radar Table',
  'map-table': 'Map Table',
  lineTable: 'Line Table',
  barTable: 'Bar Table',
  radarTable: 'Radar Table',
  mapTable: 'Map Table',
  heatmapTable: 'Heatmap Table',
  sankeyTable: 'Sankey Table',
  pieTable: 'Pie Table',
  proTable: 'Chart',
  formula: 'Formula',
  insertFormula: 'Insert Formula',
  insertFlow: 'Insert Flow',
  insertSeq: 'Insert Seq',
  insertState: 'Insert State',
  insertClass: 'Insert Class',
  insertPie: 'Insert Pie',
  scatterTable: 'Scatter Table',
  insertGantt: 'Insert Gantt',
  checklist: 'Checklist',
  ol: 'Ordered List',
  ul: 'Unordered List',
  undo: 'Undo',
  redo: 'Redo',
  previewClose: 'Preview Close',
  codeTheme: 'Code Theme',
  switchModel: 'Switch Model',
  switchPreview: 'Switch Preview',
  switchEdit: 'Switch Edit',
  classicBr: 'Classic New Line',
  normalBr: 'Normal New Line',
  settings: 'Settings',
  mobilePreview: 'Mobile Preview',
  copy: 'Copy',
  export: 'Export',
  underline: 'Underline',
  pinyin: 'Pinyin',
  pastePlain: 'Paste as Plain Text',
  pasteMarkdown: 'Paste as Markdown',
  hide: 'Hide Toolbar',
  exportToPdf: 'Export to PDF',
  exportScreenshot: 'Screenshot',
  exportMarkdownFile: 'Export Markdown File',
  exportHTMLFile: 'Export preview HTML File',
  exportWordFile: 'Export to Word',
  heading1: 'H1 Heading',
  heading2: 'H2 Heading',
  heading3: 'H3 Heading',
  panel: 'Panel',
  detail: 'Detail',
  complement: 'Complement',
  summary: 'Summary',
  justify: 'justify',
  justifyLeft: 'Left',
  justifyCenter: 'Center',
  justifyRight: 'Right',
  align: 'Align',
  alignLeft: 'Align Left',
  alignCenter: 'Align Center',
  alignRight: 'Align Right',
  alignJustify: 'Align Justify',
  alignFloatLeft: 'Align Float Left',
  alignFloatRight: 'Align Float Right',
  publish: 'Publish',
  colorPickerText: 'Text',
  colorPickerBackground: 'Background',
  colorPickerClear: 'Clear Color',
  colorPickerRecentColors: 'Recent Colors',
  colorPickerPresetColors: 'Preset Colors',
  small: 'Small',
  medium: 'Medium',
  large: 'Large',
  superLarge: 'Super Large',
  detailDefaultContent:
    'Click to expand more\nContent\n++- Expand by default\nContent\n++ Collapse by default\nContent',
  inlineCode: 'Inline Code',
  codeBlock: 'Code Block',
  inlineMath: 'Inline Math',
  mathBlock: 'Math Block',
  shortcutKeySetting: 'Keyboard Shortcuts',
  editShortcutKeyConfigTip: 'Double-click the shortcut key area or click the edit button to edit',
  editingShortcutKeyConfigTip: 'Press Enter to save, Backspace to remove the newly added key',
  staticShortcutTip: 'Built-in shortcuts cannot be modified',
  disabledShortcutTip: 'Shortcuts are currently disabled',
  cursorPosition: 'Cursor Position',
  wordCount: 'Word Count',
  wordCountP: 'P',
  wordCountW: 'W',
  wordCountC: 'C',
  wordCountL: 'L',
  wordCountImg: 'Image',
  wordCountCode: 'Code',
  wordCountChinese: 'Chinese',
  wordCountEnglish: 'English Word',
  wordCountNumber: 'Number',
  wordCountSymbol: 'Symbol',
  deleteColumn: 'delete column',
  deleteRow: 'delete row',
  addRow: 'add row',
  addCol: 'add column',
  moveRow: 'move row',
  moveCol: 'move column',
  shortcutStaticTitle: 'The following shortcuts cannot be modified',
  shortcutStatic1: 'Indent the whole line to the left',
  shortcutStatic2: 'Indent the whole line to the right',
  shortcutStatic3: 'Duplicate and paste a line',
  shortcutStatic4: 'Insert a blank line below',
  shortcutStatic5: 'Insert a blank line above',
  shortcutStatic6: 'Swap with the line above',
  shortcutStatic7: 'Swap with the line below',
  shortcutStatic8: 'Delete a line',
  shortcutStatic9: 'Select to the left by word',
  shortcutStatic10: 'Select to the right by word',
  shortcutStatic11: 'Delete by word',
  shortcutStatic12: 'Select the content inside parentheses',
  shortcutStatic13: 'Insert multiple cursors',
  shortcutStatic14: 'Select each line of the text block separately',
  shortcutStatic15: 'Find',
  shortcutStatic16: 'Select all occurrences of the word',
  shortcutStatic17: 'Undo',
  shortcutStatic18: 'Redo',
  leftMouseButton: 'left mouse button',
  disableShortcut: 'Disable all shortcuts',
  enableShortcut: 'Enable all shortcuts',
  recoverShortcut: 'Restore default configuration',
  search: 'Search/Replace',
  autoWrap: 'Auto Wrap',
  footnoteTitle: 'Footnote',
  searchFor: 'Search for',
  replaceWith: 'Replace with',
  previousMatch: 'Previous Match',
  nextMatch: 'Next Match',
  replace: 'Replace',
  replaceAll: 'Replace All',
  regExpSearch: 'RegExp Search',
  caseSensitiveSearch: 'CaseSensitive Search',
  wholeWordSearch: 'Whole Word Search',
  matchesFoundText: 'matches found.',
  toggleReplace: 'Toggle Replace',
  close: 'Close',
  border: 'Border',
  shadow: 'Shadow',
  radius: 'Radius',
  customShortcut: 'Custom Shortcuts',
  staticShortcut: 'Built-in Shortcuts',
  edit: 'Edit',
  save: 'Save',
  cancel: 'Cancel',
  saveAsImage: 'Save as Image',
  mapChartLoading: 'Loading map data',
  mapChartLoadingTip: 'If it takes a long time to load, please check your network connection',
  mapChartError: 'Map data loading failed',
  mapChartErrorTip: 'Please check the data source or network connection',
  mapChartRetry: 'Click to reload',
  chartRenderError: 'Chart render failed',
  chartLibraryNotLoadedTip: 'ECharts chart library not loaded',
  radarData: 'Radar chart data',
  scatterData: 'Scatter data',
  pieData: 'Data distribution',
  heatmapData: 'Heatmap data',
  mapData: 'Map data',
  maxValue: 'Max value',
  minValue: 'Min value',
  high: 'High',
  low: 'Low',
  mermaidSource: 'Source',
  mermaidPreview: 'Preview',
};
